<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.haberler.tanimlama.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="projeForm" :rules="rulesProjeler" ref="projeForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                                prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.projeForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}}</span>
                                                <el-input
                                                        v-if="VisibleA" v-model="projeForm.link"
                                                        v-on:change="linkChange = false;$store.commit('changeTabsClose', false)"
                                                        v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                        style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    :disabled="disabled"
                                                    v-model="projeForm.baslik"
                                                    v-on:change="linkTespit(); $store.commit('changeTabsClose', false)"
                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.altbaslik")'
                                                      prop="altbaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      :disabled="disabled"
                                                      v-model="projeForm.altbaslik"
                                                      :placeholder='$t("src.views.apps.haberler.tanimlama.altbaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="projeForm.icerik"
                                                      :disabled="disabled"
                                                      @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.resim") + " (800x600)"'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            :disabled="disabled"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                              :disabled="disabled"
                                                              id="seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              v-model="projeForm.seoBaslik"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                              :disabled="disabled"
                                                              v-on:focus="seoIcerikChange = false"
                                                              type="textarea"
                                                              v-model="projeForm.seoIcerik"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="projeForm.dil.en.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false); projeForm.dil.en.seoBaslik = projeForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                      prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="projeForm.dil.en.altbaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="projeForm.dil.en.icerik"
                                                      @input="seoIcerikENTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikENTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              v-model="projeForm.dil.en.seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikDEChange = false"
                                                              v-model="projeForm.dil.en.seoIcerik">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                :disabled="disabled"
                                                v-model="projeForm.durum"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.durumPlace")'
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="projeTanimlama('projeForm',projeForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="projeForm.durum === '1'">
                                        {{$t('src.views.apps.haberler.tanimlama.haberEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('projeForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip content='Çöp Kutusuna At' :open-delay="500" placement="bottom">
                                    <el-button class="cop" v-on:click="projeTanimlama('projeForm','2')"
                                               type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.kategori")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="kategori">
                                            <el-select
                                                    :disabled="disabled"
                                                    v-model="projeForm.kategori"
                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.kategoriPlace")'
                                                    style="width: 100%"
                                                    v-on:change="kategoriChange">
                                                <el-option v-for="item in kategoriListe"
                                                           :key="item.pkategoriId"
                                                           :label="item.baslik"
                                                           :value="item.pkategoriId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.kategoriAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.resimKonum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projeForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="projeForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="50%" height="50%">
                                            <img v-if="projeForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="50%" height="50%">
                                            <img v-if="projeForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="50%" height="50%">
                                            <img v-if="projeForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.resimKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.menuKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projeForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="projeForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="50%" height="50%">
                                            <img v-if="projeForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.menuKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.galeriKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projeForm.galeriKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="projeForm.galeriKonum === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="50%" height="50%">
                                            <img v-if="projeForm.galeriKonum === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.galeriKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.tarih")' name="6">
                                <el-row :gutter="5">
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                        <el-row>
                                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                                <el-form-item style="position: relative;top: -25px"
                                                              :label='$t("src.views.apps.haberler.tanimlama.baslamaTarihi")'
                                                              prop="tarih">
                                                    <el-date-picker class="select-wide" type="datetime"
                                                                    :disabled="disabled"
                                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.tarihPlace")'
                                                                    :picker-options="dateRangeOptions"
                                                                    v-model="projeForm.tarih"
                                                                    format="yyyy-MM-dd HH:mm:ss"
                                                                    value-format="yyyy-MM-dd HH:mm:ss">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                                <el-checkbox v-if="!checkedTarih" style="margin-bottom: 15px"
                                                             v-model="checkedTarih">
                                                    {{$t("src.views.apps.haberler.tanimlama.bitisTarihi")}}
                                                </el-checkbox>
                                                <el-col v-if="checkedTarih" :lg="24" :md="24" :sm="24" :xs="24"
                                                        class="col-p">
                                                    <el-form-item style="position: relative;top: -20px"
                                                                  :label='$t("src.views.apps.haberler.tanimlama.bitisTarihi")'
                                                                  prop="bitisTarihi">:
                                                        <el-date-picker class="select-wide" type="datetime"
                                                                        :disabled="disabled"
                                                                        :placeholder='$t("src.views.apps.haberler.tanimlama.bitisTarihiPlace")'
                                                                        :picker-options="dateRangeOptions"
                                                                        v-model="projeForm.bitisTarihi"
                                                                        format="yyyy-MM-dd HH:mm:ss"
                                                                        value-format="yyyy-MM-dd HH:mm:ss">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              title='Proje Hakkında' name="10">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.sayac")'
                                                      prop="sayac">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                      v-mask="'######'"
                                                      v-model="projeForm.sayac"></el-input>
                                        </el-form-item>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                            <el-form-item :label='$t("src.views.apps.haberler.tanimlama.begen")'
                                                          prop="begen">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                          v-mask="'######'"
                                                          v-model="projeForm.begen"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                            <el-form-item label='Url'
                                                          prop="url">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="projeForm.url"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.galeriKonum" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.galeriKonum" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projeForm.galeriKonum" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import draggable from "vuedraggable";
    import JQuery from 'jquery';

    let $ = JQuery;

    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import projeService from '../../../WSProvider/ProjeService'
    import projeKategoriService from '../../../WSProvider/ProjeKategoriService'
    import notification from '../../../notification'
    import functions from '../../../functions'

    var today = new Date();
    var yil = today.getFullYear();
    var ay = (today.getMonth() + 1);
    var gun = today.getDate();
    var moment = require('moment');


    let time = moment().format('YYYY-MM-DD HH:mm:ss');

    export default {
        name: "ProjelerTanimla",
        components: {
            draggable,
        },
        watch: {
            imageListMain: function (val) {
                if (val.length === 1) {
                    this.projeForm.resimKonum = "1";
                    this.projeForm.galeriKonum = "0";
                } else if (val.length > 1) {
                    this.projeForm.galeriKonum = "1";
                } else {
                    this.projeForm.resimKonum = "0";
                    this.projeForm.galeriKonum = "0";
                }
            },
        },
        mounted() {
            this.getKategoriListe();
        },
        data() {
            return {
                seoBaslikLimit: 0,
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                path: projeService.path,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr',
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListMain: [],
                imageListServer: [],
                fileListMain: [],
                fileListServer: [],
                VisibleA: false,
                visibleSil: false,
                duzenleBtnVisible: true,
                seoIcerikDEChange: true,
                dynamicTags: [],
                visibleWebSite: false,
                disabled: false,
                linkChange: true,
                seoIcerikChange: true,
                checkedTarih: false,
                kategoriId: '',
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                kategoriListe: [],
                dialogImgServerVisible: false,
                linkVisible: false,
                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                projeForm: {
                    kategori: '',
                    baslik: '',
                    altbaslik: '',
                    icerik: '',
                    resim: [],
                    belge: [],
                    link: '',
                    url: '',
                    sayac: 0,
                    begen: 0,
                    resimKonum: '0',
                    menuKonum: '0',
                    galeriKonum: '0',
                    kaynakca: '',
                    webSite: [],
                    tarih: time,
                    bitisTarihi: '',
                    durum: '1',
                    seoBaslik: '',
                    seoIcerik: '',
                    firstDayOfWeek: 1,
                    dil: {
                        en: {
                            baslik: '',
                            altbaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        }
                    },
                },
                rulesProjeler: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Proje Başlığı Giriniz",
                        trigger: 'blur'
                    }],
                    seoBaslik: [{
                        max: 70,
                        message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                        trigger: 'change'
                    }],
                    seoIcerik: [{
                       max: 160,
                        message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                        trigger: 'change'
                    }],
                },
            }
        },
        methods: {
            seoBaslikChange(id) {
                this.seoBaslikLimit = this.projeForm.seoBaslik.length;
                if (this.seoBaslikLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('proje').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: projeService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, "proje-" + functions.randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            getKategoriListe() {
                projeKategoriService.pKategoriListesi(1).then(response => {
                    if (response.status === 200) {
                        if (response.data.length === 0) {
                            notification.Status('warning', this, 'Kategori listesi boş! Lütfen önce kategori tanımlayınız.');
                            this.disabled = true;
                        } else {
                            this.kategoriListe = response.data;
                        }
                        if (response.data.length > 0) {
                            this.projeForm.kategori = response.data[0].pkategoriId;
                            this.kategoriId = response.data[0].pkategoriId;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            linkTespitLink() {
                let self = this;
                if (this.projeForm.link) {
                    seoService.linkKontrol(self.projeForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.projeForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.projeForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.projeForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.projeForm.baslik) {
                            self.projeForm.seoBaslik = self.projeForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.projeForm.link = response.data;
                            }
                        } else if (!self.projeForm.baslik) {
                            self.linkVisible = false;
                            self.projeForm.link = '';
                            self.projeForm.seoBaslik = '';
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange && this.projeForm.icerik) {
                    const myStr = functions.strip_html_tags(this.projeForm.icerik);
                    this.projeForm.seoIcerik = myStr.substring(0, 140);
                } else this.projeForm.seoIcerik = '';
            },

            kategoriChange(val) {
                if (val === '4') {
                    this.visibleWebSite = true;
                } else {
                    this.visibleWebSite = false;
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('haberler', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.projeForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "proje-" + functions.randomText(7) + '-' + this.projeForm.link + ".jpg";
                        } else {
                            imgname = "proje-" + functions.randomText(7) + '-' + this.projeForm.link + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "proje-" + functions.randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "proje-" + functions.randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageUploadtoServer(file) {
                let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                if (obj === undefined) {
                    var item = {
                        name: "proje-" + file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    notification.Status('warning', this, 'Bu resim zaten mevcut');
                }

            },
            projeTanimlama(formName, durum) {
                let self = this;
                this.projeForm.resim = [];
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.projeForm.resim.push(e.name);
                        });
                        dil = {
                            en: {
                                baslik: this.projeForm.dil.en.baslik,
                                altBaslik: this.projeForm.dil.en.altbaslik,
                                icerik: this.projeForm.dil.en.icerik,
                                seoBaslik: this.projeForm.dil.en.seoBaslik,
                                seoIcerik: this.projeForm.dil.en.seoIcerik
                            },
                        };
                        projeService.projeTanimlama(this.projeForm.link, this.projeForm.kategori, this.projeForm.baslik,
                            this.projeForm.altbaslik, this.projeForm.icerik,this.projeForm.resim, this.projeForm.resimKonum,
                            this.projeForm.menuKonum, this.projeForm.galeriKonum,this.projeForm.url, this.projeForm.tarih, this.projeForm.bitisTarihi,
                            this.projeForm.sayac, this.projeForm.begen, this.projeForm.seoBaslik, this.projeForm.seoIcerik,dil).then((response) => {
                            if (response.status === 200) {
                                switch (durum) {
                                    case '0':
                                        notification.Status('success', this, 'Proje taslağa kaldırıldı.');
                                        break;
                                    case '1':
                                        notification.Status('success', this, 'Proje başarıyla eklendi.');
                                        break;
                                    case '2':
                                        notification.Status('success', this, 'Proje arşive kaldırıldı.');
                                        break;
                                }
                                this.resetForm(formName);
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir haber zaten mevcut');

                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.visibleWebSite = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.projeForm.kategori = this.kategoriId;
                this.projeForm.belge = [];
                this.projeForm.link = null;
                this.linkVisible = false;
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }
        }
    }

</script>

<style scoped>

    .upload-demo ul {
        margin: 0;
        padding: 0;
        list-style: none;
        background: aliceblue;
        width: 50%;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .el-tag + .el-tag {
        margin-left: 10px;
    }


</style>